import { ReactNode } from "react";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "@tellescope/ui";
import { RouterContent } from "./RouterContent";
import { TellescopeTanstackQueryProvider } from "../components";
import { AuthProvider } from "../providers/AuthProvider";
import { PendoProvider } from "../providers/PendoProvider";

export interface RouterProps {
  children?: ReactNode;
}

export const Router = ({ children }: RouterProps) => {
  const basename = import.meta.env.BASE_URL.replace(/\/$/, "");

  return (
    <BrowserRouter basename={basename}>
      <AuthProvider>
        <PendoProvider>
          <TellescopeTanstackQueryProvider>
            <RouterContent />
            <Toaster />
          </TellescopeTanstackQueryProvider>
          {children}
        </PendoProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};
